import { TextLong } from "@hm/fundamental"
import { ReactNode } from "react"

interface SectionContentProps {
	content: string | string[] | ReactNode
}

export const SectionContent = ({ content }: SectionContentProps) => {
	if (typeof content === "string") {
		return <TextLong className="text-foreground_faded">{content}</TextLong>
	}

	if (Array.isArray(content)) {
		return (
			<div>
				{content.map((text, index) => (
					<TextLong
						key={`text-${index}-${text.slice(0, 20)}`}
						className="block text-foreground_faded"
					>
						{text}
					</TextLong>
				))}
			</div>
		)
	}

	return <div className="text-foreground_faded">{content}</div>
}
